import {until} from 'lit-html/directives/until';
import {repeat} from 'lit-html/directives/repeat';
import '@modules/auth-context';
import {formLabels, generalLabels, toastStatus, qrCodes} from '@modules/i18n-labels';
import '@modules/product-card-info';
import '@modules/multi-classroom-select-group-filter';
import '@modules/class-selection';
import '@modules/auth-context';
import '@modules/aofl-form';
import '@modules/phone-input';
import {hasOneOfPermissions} from '@modules/permissions';
import {permissions} from '@modules/constants-enumerate';

export default (ctx, html) => html`
${ctx.disabled
  ? html`
    <div class="alert alert-warning">
      ${ctx.hasPerms ? until(toastStatus.saveFailTpRosteringConnected) : until(toastStatus.insufficentPermissionsEdit)}
    </div>`
  : ''}

<aofl-form>
  <form class="horizontal-form" @submit="${ctx.submit}" novalidate autocomplete="off">
    <div class="text-right pr-5 pb-2">
      ${until(formLabels.requiredField)}
    </div>

    ${renderFormFields(ctx, html)}

    ${renderClasses(ctx, html)}

    ${renderProducts(ctx, html)}

    <slot></slot>

  </form>
</aofl-form>
`;

const showIf = (conditionToShow, content) => {
  if (conditionToShow === true) {
    return content;
  }
};

const renderFormFields = (ctx, html) => html`
<div class="row mb-3">
  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <label for="first-name" class="col-sm-4 col-form-label">${until(ctx.__('<tt-BpOEnTMN>', '<span aria-hidden="true">*</span>First Name'))}</label>
      <div class="col-sm-8">
        <input name="first-name" class="form-control form-control-sm  ${!ctx.form.firstName.valid ? 'is-invalid': ''}" id="first-name" @input="${ctx.firstNameUpdated}" .value="${ctx.firstName}" ?disabled="${ctx.disabled}">
        ${!ctx.form.firstName.isRequired.valid ? html`<p class="invalid-feedback d-block mb-0">${until(ctx.__('<tt-2hQwhfDu>', 'First name is required.'))}</p>`: ''}
      </div>
    </div>
  </div>
  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <label for="last-name" class="col-sm-4 col-form-label">${until(ctx.__('<tt-aayKney0>', 'Last Name'))}</label>
      <div class="col-sm-8">
        <input name="last-name" class="form-control form-control-sm" id="last-name" @input="${ctx.lastNameUpdated}" .value="${ctx.lastName}" ?disabled="${ctx.disabled}">
      </div>
    </div>
  </div>
  ${ctx.teacherLoginEnabled && !ctx.isTeacherCreate ? html `
  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <label for="email" class="col-sm-4 col-form-label">${until(generalLabels.loginEmail)}</label>
      <div class="col-sm-8">
        <input type="email" name="email" disabled class="form-control form-control-sm" id="email" @input="${ctx.emailUpdated}"  .value="${ctx.email}" >
      </div>
    </div>
  </div>
  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <label for="phone" class="col-sm-4 col-form-label">${until(generalLabels.loginPhone)}</label>
      <div class="col-sm-8">
        <phone-input name="phone" id="phone" .initialValue="${ctx.phone}" @click="${ctx.phoneUpdated}" @keyup="${ctx.phoneUpdated}" @blur="${ctx.validateEmailAndPhone}" disabled class="form-control form-control-sm" style="background-color: #e9ecef;" .value="${ctx.phone}"></phone-input>
      </div>
    </div>
  </div>
  ` : ''}
  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <label for="contact-email" class="col-sm-4 col-form-label">${until(generalLabels.contactEmail)}</label>
      <div class="col-sm-8">
        <input type="email" name="contact-email" class="form-control form-control-sm ${!ctx.form.contactEmail.valid || !ctx.form.isThereEmailOrPhone.valid ? 'is-invalid': ''}" id="contact-email" @input="${ctx.contactEmailUpdated}"  .value="${ctx.contactEmail}" ?disabled="${ctx.disabled}">
      </div>
      ${!ctx.form.contactEmail.valid ? html`<p class="invalid-feedback col-sm-8 offset-sm-4 d-block mb-0">${until(generalLabels.invalidEmailError)}</p>`: ''}
    </div>
  </div>
  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <label for="contact-phone" class="col-sm-4 col-form-label">${until(generalLabels.contactPhone)}</label>
      <div class="col-sm-8">
        <phone-input name="contact-phone" id="contact-phone" .initialValue="${ctx.contactPhone}" @click="${ctx.contactPhoneUpdated}" @keyup="${ctx.contactPhoneUpdated}" class="form-control form-control-sm ${!ctx.form.contactPhone.valid || !ctx.form.isThereEmailOrPhone.valid ? 'is-invalid': ''}" style="${(ctx.disabled) ? 'background-color: #e9ecef;' : ''}" ?disabled="${ctx.disabled}" .value="${ctx.contactPhone}"></phone-input>
      </div>
      ${!ctx.form.contactPhone.valid ? html`<p class="invalid-feedback col-sm-8 offset-sm-4 d-block mb-0">${until(generalLabels.invalidPhoneError)}</p>`: ''}
    </div>
  </div>

  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <div class="col col-form-label">${until(ctx.__('<tt-OQ1avYvB>', 'Preferred Communication'))}</div>
      <div class="col d-flex align-items-center justify-content-center form-control form-control-sm border-0">
        <input type="radio" value="email" id="email-comm" name="preferred-communication" class="mr-2" @change="${ctx.preferredCommunicationUpdated}" .checked="${ctx.preferredCommunication === 'email'}" ?disabled="${ctx.disabled}">
        <label for="email-comm" class="mb-0 mr-4">${until(ctx.__('<tt-oWIWBQ+o>', 'Email'))}</label>
        <input type="radio" value="phone" id="phone-comm" name="preferred-communication" class="mr-2" @change="${ctx.preferredCommunicationUpdated}" .checked="${ctx.preferredCommunication === 'phone'}" ?disabled="${ctx.disabled}">
        <label for="phone-comm" class="mb-0">${until(ctx.__('<tt-8CgISWET>', 'Phone'))}</label>
      </div>
    </div>
  </div>

  <div class="col-md-12 col-lg-6">
    <div class="form-group row">
      <label for="external-id" class="col-sm-4 col-form-label align-items-start"><span>${until(ctx.__('<tt-5wv32+ql>', 'Unique Roster Id'))}</span></label>
      <div class="col-sm-8">
        <input class="form-control form-control-sm ${!ctx.form.externalId.valid ? 'is-invalid': ''}" id="external-id" name="external-id" @input="${ctx.externalIdUpdated}" @blur="${ctx.validateExternalId}" .value="${ctx.externalId}" ?disabled="${ctx.disabled || !hasOneOfPermissions([permissions.TEACHER_EDIT])}">
      </div>
      ${!ctx.form.externalId.duplicate.valid ? html`<p class="invalid-feedback col-sm-8  offset-sm-4 d-block mb-0">${until(ctx.__('<tt-OpWsfG5+>', 'External id already in use'))}</p>`: ''}
    </div>
  </div>
</div>

${!ctx.form.isThereEmailOrPhone.valid ? html`<p class="invalid-feedback text-center d-block mb-0">${until(ctx.__('<tt-cJIuJEig>', 'Provide an email or phone number.'))}</p>`: ''}
`;

const renderClasses = (ctx, html) => {
  return html`
    <hr>

    <div class="d-flex align-items-center">
      <h1 class="h3 p-0 m-0 mr-5">${until(ctx.__('<tt-bBSy0oHi>', 'Classes'))}</h1>
      ${!ctx.disabled ? html`
      <button class="btn btn-link" type="button" @click="${() => ctx.showEmptyClassSelection = true}">
        <span class="ai ai-create"></span> ${until(ctx.__('<tt-zp9buzSv>', 'Assign to an additional school'))}
      </button>` : '' }
    </div>

    <class-selection
      class="mb-5"
      @data-updated="${ctx.dataUpdated}"
      @class-clicked="${ctx.classClicked}"
      .data="${{
        classesBySchool: ctx.$classesGroupedBySchool,
        groupInfo: ctx.groupInfo,
        addNewSchool: ctx.showEmptyClassSelection,
        disabled: ctx.disabled
      }}">
    </class-selection>
  `;
};

const renderProducts = (ctx, html) => html`
  <hr>

  <div class="mb-5">
    <div>
      <h1 class="h4 d-inline-block">${until(ctx.__('<tt-/e8LY45A>', 'Products'))}</h1>
      ${showIf(
        ctx.qrEnabled,
        html`<auth-context class="d-inline-block" show-on-auth .permissions="${[permissions.EXPORT_ALL]}" .restricted="${[permissions.SPONSOR, permissions.HIDE_STUDENT]}">
          <a
            data-hide-pii="true"
            data-bi-id="qr_code_generate_teacher_${ctx.teacherId}"
            data-bi-action="QR code generate teacher ${ctx.teacherId}"
            target="_blank"
            href=${ctx.downloadEducatorCenterQRCode()}>
            ${until(qrCodes.DOWNLOAD_QR_CODES)}
          </a>
        </auth-context>`
      )}
    </div>

    <div class="row mb-5">
      ${repeat(ctx.products, (item) => item.product, (item) => renderProductCard(html, item))}
    </div>

    <p class="text-center text-sm">
      ${until(ctx.__('<tt-rMYRk8Cs>', 'Teacher licenses are determined by what access students have in their classes.'))}
    </p>
  </div>
`;

const renderProductCard = (html, item) => html`
  <div class="col-12 col-md-12 col-lg-6">
    <product-card-info class="d-block" .product="${item}" user-type="teacher"></product-card-info>
  </div>
`;
